export type AnalyticsEvent = {
  name: string;
};

// IMPORTANT: use the name of the event as the key
export const AnalyticsEvents: Record<string, Record<string, AnalyticsEvent>> = {
  dynamicPicker: {
    view: { name: 'dynamic_picker_view' },
    choosePhotosClick: { name: 'dynamic_picker_choose_photos_click' },
    continueClick: { name: 'dynamic_picker_continue_click' },
    closeClick: { name: 'dynamic_picker_close_click' },
    sourceClick: { name: 'dynamic_picker_source_click' },
    sourceAttachClick: { name: 'dynamic_picker_source_attach_click' },
    sourceAttachSuccess: { name: 'dynamic_picker_source_attach_success' },
    sourceAttachError: { name: 'dynamic_picker_source_attach_error' },
    allPhotosSelectClick: { name: 'dynamic_picker_all_photos_select_click' },
    photoSelectClick: { name: 'dynamic_picker_photo_select_click' },
    sourcePhotoUploaded: { name: 'dynamic_picker_source_photo_uploaded' },
    shareLink: { name: 'dynamic_picker_share_link' },
    loadPhotosFromSourceError: { name: 'dynamic_picker_load_photos_from_source_error' },
  },
  tutorial: {
    open: { name: 'tutorial_open' },
    continueClick: { name: 'tutorial_continue_click' },
    closeClick: { name: 'tutorial_close_click' },
  },
  upselling: {
    view: { name: 'upselling_view' },
    declined: { name: 'upselling_declined' },
    accepted: { name: 'upselling_accepted' },
  },
  personalize: {
    start: { name: 'personalize_start' }, // personalize.start takes n_photos and n_products as data. For frames photos and products will always match, but this will be different prints each format print will be handled as different product.
    lookupView: { name: 'personalize_lookup_view' },
    lookupSelect: { name: 'personalize_lookup_select' },
    lookupSelectConfirmClick: { name: 'personalize_lookup_select_confirm_click' },
    otherOptionsClick: { name: 'personalize_other_options_click' },
    tutorialClick: { name: 'personalize_tutorial_click' },
    addProductClick: { name: 'personalize_add_product_click' },
    addPhotoClick: { name: 'personalize_add_photo_click' },
    multiproductView: { name: 'personalize_multiproduct_view' },
    multiproductClick: { name: 'personalize_multiproduct_click' },
    deleteProductClick: { name: 'personalize_delete_product_click' },
    deleteProductConfirmClick: { name: 'personalize_delete_product_confirm_click' },
    dynamicPickerContinueClick: { name: 'personalize_dynamic_picker_continue_click' },
    backToHomeClick: { name: 'personalize_back_to_home_click' },
    goBackAlertView: { name: 'personalize_goBackAlert_view' },
    goBackAlertDeclined: { name: 'personalize_goBackAlert_declined' },
    goBackAlertAccepted: { name: 'personalize_goBackAlert_accepted' },
    emptySpaceAlertView: { name: 'personalize_empty_space_alert_view' },
    emptySpaceAlertClick: { name: 'personalize_empty_space_alert_click' },
    undo: { name: 'personalize_undo' },
    redo: { name: 'personalize_redo' },
    editImageClick: { name: 'personalize_edit_image_click' },
    expandPhotoClick: { name: 'personalize_expand_photo_click' },
    backToProductClick: { name: 'personalize_back_to_product_click' },
    qualityAlertView: { name: 'personalize_quality_alert_view' },
    qualityAlertOptionClick: { name: 'personalize_quality_alert_option_click' },
    supportClick: { name: 'personalize_support_click' },
    continueClick: { name: 'personalize_continue_click' },
    menuClick: { name: 'personalize_menu_click' },
    optionView: { name: 'personalize_option_view' },
    menuBackClick: { name: 'personalize_menu_back_click' },
    duplicatePhotoClick: { name: 'personalize_duplicate_photo_click' },
    modifyNCopyClick: { name: 'personalize_modify_n_copy_click' },
    selectionFilterClick: { name: 'personalize_selection_filter_click' },
    deselectAllPhotoClick: { name: 'personalize_deselect_all_photo_click' },
    viewLayoutClick: { name: 'personalize_view_layout_click' },
    tabClick: { name: 'personalize_tab_click' },
    addProductOptionSelect: { name: 'personalize_add_product_option_select' },
    cutPhotoAlertView: { name: 'personalize_cut_photo_alert_view' },
    cutPhotoAlertClick: { name: 'personalize_cut_photo_alert_click' },
    photoFrameView: { name: 'personalize_photo_frame_view' },
    photoFrameSaveClick: { name: 'personalize_photo_frame_save_click' },
    photoFrameSaveOptionClick: { name: 'personalize_photo_frame_save_option_click' },
    photoFramePostponeCutReview: { name: 'personalize_photo_frame_postpone_cut_review' },
    supportMessageSend: { name: 'personalize_support_message_send' },
    yourPhotoClick: { name: 'personalize_your_photo_click' },
    yourPhotoOpen: { name: 'personalize_your_photo_open' },
    yourPhotoClose: { name: 'personalize_your_photo_close' },
    photoSelectClick: { name: 'personalize_photo_select_click' },
    addToCartClick: { name: 'personalize_add_to_cart_click' },
    addToCartRedirect: { name: 'personalize_add_to_cart_redirect' },
    minimumQuantityAlertView: { name: 'personalize_minimum_quantity_alert_view' },
    minimumQuantityAlertClick: { name: 'personalize_minimum_quantity_alert_click' },
    maximumQuantityAlertView: { name: 'personalize_maximum_quantity_alert_view' },
    maximumQuantityAlertClick: { name: 'personalize_maximum_quantity_alert_click' },
    bottomSheetLookupClick: { name: 'personalize_bottom_sheet_lookup_click' },
    uploadPhotoErrorView: { name: 'personalize_upload_photo_error_view' },
    uploadPhotoErrorClick: { name: 'personalize_upload_photo_error_click' },
    productNotAvailableView: { name: 'personalize_product_not_available_view' },
    productNotAvailableClick: { name: 'personalize_product_not_available_click' },
    photoFormatClick: { name: 'personalize_photo_format_click' },
    photoPaperClick: { name: 'personalize_photo_paper_click' },
    selectionDeleteClick: { name: 'personalize_selection_delete_click' },
    zoomClick: { name: 'personalize_zoom_click' },
    zoomCloseClick: { name: 'personalize_zoom_close_click' },
    qualityAlertClick: { name: 'personalize_quality_alert_click' },
    editFormatClick: { name: 'personalize_edit_format_click' },
    printOptionsClick: { name: 'personalize_print_options_click' },
    photoDrawerOrderBy: { name: 'personalize_photo_drawer_order_by' },
    photoDrawerAddPhotos: { name: 'personalize_photo_drawer_add_photos' },
    photoDrawerSelectPhotos: { name: 'personalize_photo_drawer_select_photos' },
  },
  modifyPhoto: {
    view: { name: 'modify_photo_view' },
    frameOptionClick: { name: 'modify_photo_frame_option_click' },
    orientationOptionClick: { name: 'modify_photo_orientation_option_click' },
    filterOptionClick: { name: 'modify_photo_filter_option_click' },
    borderTypeOptionClick: { name: 'modify_photo_border_type_option_click' },
    replaceClick: { name: 'modify_photo_replace_click' },
    filterClick: { name: 'modify_photo_filter_click' },
    borderTypeClick: { name: 'modify_photo_border_type_click' },
    rotateClick: { name: 'modify_photo_rotate_click' },
    zoomClick: { name: 'modify_photo_zoom_click' },
    adjustClick: { name: 'modify_photo_adjust_click' },
    adjustOptionClick: { name: 'modify_photo_adjust_option_click' },
    adjustRestoreClick: { name: 'modify_photo_adjust_restore_click' },
    restoreClick: { name: 'modify_photo_restore_click' },
    undoClick: { name: 'modify_photo_undo_click' },
    redoClick: { name: 'modify_photo_redo_click' },
    saveClick: { name: 'modify_photo_save_click' },
    unsavedChangesView: { name: 'modify_photo_unsaved_changes_view' },
    unsavedChangesClick: { name: 'modify_photo_unsaved_changes_click' },
    flipImage: { name: 'modify_photo_flip_image' },
  },
  user: {
    loginFormView: { name: 'user_login_form_view' },
    loginView: { name: 'user_login_view' },
    loginSuccess: { name: 'user_login_success' },
    loginError: { name: 'user_login_error' },
    registrationFormView: { name: 'user_registration_form_view' },
    registrationSuccess: { name: 'user_registration_success' },
    registrationError: { name: 'user_registration_error' },
    createPasswordError: { name: 'user_create_password_error' },
    forgotPasswordView: { name: 'user_forgot_password_view' },
    consentFormView: { name: 'user_consent_form_view' },
  },
  photoSources: {
    detachSourceClick: { name: 'photo_sources_detach_source_click' },
    detachSourceConfirmClick: { name: 'photo_sources_detach_source_confirm_click' },
  },
  product: {
    infoClick: { name: 'product_info_click' },
    infoClose: { name: 'product_info_close' },
  },
  lookup: {
    view: { name: 'lookup_view' },
    select: { name: 'lookup_select' },
    continueClick: { name: 'lookup_continue_click' },
    infoClick: { name: 'lookup_info_click' },
    backClick: { name: 'lookup_back_click' },
  },
  sharePhoto: {
    pageView: { name: 'share_photo_page_view' },
    selectClick: { name: 'share_photo_select_click' },
    uploadStart: { name: 'share_photo_upload_start' },
    uploadComplete: { name: 'share_photo_upload_complete' },
    uploadError: { name: 'share_photo_upload_error' },
    addedView: { name: 'editor_share_photo_added_view' },
    addedClick: { name: 'editor_share_photo_added_click' },
  },
  project: {
    saveClick: { name: 'save_project_click' },
  },
  cart: {
    addSuccess: { name: 'cart_add_success' },
  },
};

export enum loginTypeIds {
  google = 'google',
  facebook = 'facebook',
  apple = 'apple',
  email = 'email',
}

export enum AnalyticsSelectionTypes {
  select = 'select',
  deselect = 'deselect',
  deselectAll = 'deselect_all',
  selectAll = 'select_all',
}
